/* eslint-disable @next/next/no-sync-scripts */
import React, { useEffect } from 'react';

/**
 * CookiePro script elements for injection into document head
 */
/* eslint-disable react/no-unknown-property */
export const getCookieProScripts = () => [
  <script
    key='cookiepro-autoblock'
    type='text/javascript'
    src='https://cookie-cdn.cookiepro.com/consent/3c04a279-80eb-468e-9d0a-4da70d32c117/OtAutoBlock.js'
  />,
  <script
    key='cookiepro-sdk'
    src='https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js'
    data-document-language='true'
    type='text/javascript'
    charSet='UTF-8'
    data-domain-script='3c04a279-80eb-468e-9d0a-4da70d32c117'
  />,
  <script
    key='cookiepro-wrapper'
    dangerouslySetInnerHTML={{
      __html: `function OptanonWrapper() { }`,
    }}
  />,
];

/**
 * CookiePro accessibility handler component
 * Adds keyboard navigation support for the CookiePro banner
 */
export const CookieProAccessibility = () => {
  useEffect(() => {
    let hasFocusedBanner = false;

    window.onkeydown = e => {
      if (e.key === 'Tab' && !hasFocusedBanner) {
        const banner = document.getElementById('onetrust-banner-sdk');
        if (banner && e.key === 'Tab' && !hasFocusedBanner) {
          banner.setAttribute('tabindex', '0');
          banner.focus();
          hasFocusedBanner = true;
        }
      }
    };
  }, []);

  return null;
};
